import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Le montant avec sa devise, dans la langue de l'utilisateur (Yros/Kavero#413).
// `fr-FR` par défaut : les écrans qui ne passent pas la langue ne changent pas.
// Tout ce qui n'est pas une langue (un objet d'options, par exemple) est
// ignoré, comme avant que le paramètre existe.
export const formatMoney = (value, locale) => {
        const langue = typeof locale === 'string' && locale ? locale : 'fr-FR';
        return new Intl.NumberFormat(langue, { style: 'currency', currency: 'XOF' }).format(value);
    };

// Affiche un numero au format international normalise (ex: +221 77 123 45 67).
// La valeur stockee est en E.164 ; defaultCountry sert de filet pour les
// anciens numeros enregistres sans indicatif.
export const formatPhone = (value, defaultCountry = 'SN') => {
    if (!value) return '';
    const parsed = parsePhoneNumberFromString(String(value), defaultCountry);
    return parsed ? parsed.formatInternational() : value;
};

// Format brut pour l'input (ex: 12 345,67)
export const formatMoneyInput = (value) => {
    if (value === '' || value === null || isNaN(value)) return '';
    return Number(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

